import React, { memo } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { THEME } from '../../constants';
import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';
import { changeTheme } from '../../redux/global/globalReducer';

import scss from './ThemeButtons.module.scss';

const ThemeButtons = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('sidebar');

  const theme = useSelector((state) => state.global.theme);

  const handleChangeTheme = (newTheme) => {
    if (newTheme === theme) {
      return;
    }

    dispatch(changeTheme(newTheme));
    localStorage.setItem('THEME', newTheme);
  };

  return (
    <div className={scss['theme-buttons']}>
      <button
        type='button'
        onClick={() => handleChangeTheme(THEME.LIGHT)}
        className={scss['theme-button']}
        aria-label={t('lightTheme')}
        aria-pressed={theme === THEME.LIGHT}>
        <Icon
          icon={ICONS.Sun}
          className={clsx(scss['theme-icon'], theme === THEME.LIGHT && scss['theme-icon--active'])}
          cursorPointer
        />
      </button>
      <button
        type='button'
        onClick={() => handleChangeTheme(THEME.DARK)}
        className={scss['theme-button']}
        aria-label={t('darkTheme')}
        aria-pressed={theme === THEME.DARK}>
        <Icon
          icon={ICONS.Moon}
          className={clsx(scss['theme-icon'], theme === THEME.DARK && scss['theme-icon--active'])}
          cursorPointer
        />
      </button>
    </div>
  );
};

const mapStateToProps = ({ global: { theme } }) => {
  return { theme };
};

export default memo(connect(mapStateToProps, { changeTheme })(ThemeButtons));
